/* 全局注册 通用组件
* 将通过import.meta.glob自动注册
* 只需要把组件放在 本文件夹内（/src/components）即可
* 支持vue格式和jsx格式的组件
* */
import { defineAsyncComponent } from 'vue'
import { getComponentName } from '@/utils'
import PopperMyGroups from '@/components/popper-my-groups/PopperMyGroups.vue'
// 全局注册组件
export default {
    install: function (app) {
        const components = import.meta.glob('./**/*.{vue,jsx}')
        // 遍历注册组件
        for (const [path, value] of Object.entries(components)) {
            const _componentName = getComponentName(path)
            app.component(_componentName, defineAsyncComponent(value))
        }
        app.component('PopperMyGroups',PopperMyGroups)
    }
}
